import React from 'react';
import { Phone, CheckCircle, Award, Wrench } from 'lucide-react';
export function TrailerRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7058">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7059">
        <div className="container mx-auto px-4" data-id="element-7060">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7061">
            Trailer Repair
          </h1>
          <p className="text-2xl text-gray-100 text-center" data-id="element-7062">
            Our Certified and Licensed Mechanics Ensure Safety and Reliability
            of Trailer Repairs
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7063">
        <div className="max-w-4xl mx-auto" data-id="element-7064">
          {/* Certified Mechanics Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7065">
            <div className="flex items-start mb-6" data-id="element-7066">
              <Award className="text-[#B1050B] mr-4 flex-shrink-0 mt-1" size={48} data-id="element-7067" />
              <div data-id="element-7068">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7069">
                  Certified & Licensed Professionals
                </h2>
                <p className="text-lg text-gray-700 mb-4" data-id="element-7070">
                  Unlike many trailer mechanics in the area, we employ certified
                  and licensed mechanics to diagnose and repair your trailer.
                  Need frame repairs on your trailer? Our certified welder is
                  well qualified to make the repairs your trailer requires. You
                  don't need the headache of a poor trailer repair leaving you
                  stranded or worse.
                </p>
              </div>
            </div>

            <div className="bg-red-50 border-2 border-[#B1050B] rounded-lg p-6 text-center" data-id="element-7071">
              <p className="text-2xl font-bold text-[#B1050B] mb-2" data-id="element-7072">Call Now</p>
              <a href="tel:2484788382" className="text-4xl font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7073">
                248-478-8382
              </a>
            </div>
          </div>

          {/* Trailer Types */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7074">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7075">
              Trailers We Service
            </h2>

            <p className="text-lg text-gray-700 text-center mb-6" data-id="element-7076">
              We repair RV Trailers, Horse Trailers, Dog Trailers, Aluminum
              Trailers, Steel Trailers, Goose Neck Trailers, 5th Wheel Trailers,
              Bumper Trailers... We also repair semi tractor trailers.
            </p>

            <div className="grid md:grid-cols-3 gap-3" data-id="element-7077">
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7078">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7079" />
                <span className="text-gray-700" data-id="element-7080">RV Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7081">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7082" />
                <span className="text-gray-700" data-id="element-7083">Horse Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7084">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7085" />
                <span className="text-gray-700" data-id="element-7086">Dog Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7087">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7088" />
                <span className="text-gray-700" data-id="element-7089">Aluminum Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7090">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7091" />
                <span className="text-gray-700" data-id="element-7092">Steel Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7093">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7094" />
                <span className="text-gray-700" data-id="element-7095">Goose Neck Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7096">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7097" />
                <span className="text-gray-700" data-id="element-7098">5th Wheel Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7099">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7100" />
                <span className="text-gray-700" data-id="element-7101">Bumper Trailers</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded p-3" data-id="element-7102">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0" size={18} data-id="element-7103" />
                <span className="text-gray-700" data-id="element-7104">Semi Tractor Trailers</span>
              </div>
            </div>
          </div>

          {/* Specialized Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7105">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7106">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-7107" />
              We Specialize in All Trailer Repairs
            </h2>

            <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-7108">
              General Inspection, Maintenance and Part Replacement - including:
            </p>

            <div className="grid md:grid-cols-2 gap-3 mb-6" data-id="element-7109">
              <div className="flex items-start" data-id="element-7110">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7111" />
                <span className="text-gray-700" data-id="element-7112">Frames</span>
              </div>
              <div className="flex items-start" data-id="element-7113">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7114" />
                <span className="text-gray-700" data-id="element-7115">Axles</span>
              </div>
              <div className="flex items-start" data-id="element-7116">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7117" />
                <span className="text-gray-700" data-id="element-7118">Bearings</span>
              </div>
              <div className="flex items-start" data-id="element-7119">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7120" />
                <span className="text-gray-700" data-id="element-7121">Axle Bearing Repack</span>
              </div>
              <div className="flex items-start" data-id="element-7122">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7123" />
                <span className="text-gray-700" data-id="element-7124">Couplers</span>
              </div>
              <div className="flex items-start" data-id="element-7125">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7126" />
                <span className="text-gray-700" data-id="element-7127">Tongue jacks</span>
              </div>
              <div className="flex items-start" data-id="element-7128">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7129" />
                <span className="text-gray-700" data-id="element-7130">Hubs</span>
              </div>
              <div className="flex items-start" data-id="element-7131">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7132" />
                <span className="text-gray-700" data-id="element-7133">Runners</span>
              </div>
              <div className="flex items-start" data-id="element-7134">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7135" />
                <span className="text-gray-700" data-id="element-7136">Rollers</span>
              </div>
              <div className="flex items-start" data-id="element-7137">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7138" />
                <span className="text-gray-700" data-id="element-7139">Winches</span>
              </div>
              <div className="flex items-start" data-id="element-7140">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7141" />
                <span className="text-gray-700" data-id="element-7142">Lights</span>
              </div>
              <div className="flex items-start" data-id="element-7143">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7144" />
                <span className="text-gray-700" data-id="element-7145">Brakes</span>
              </div>
              <div className="flex items-start" data-id="element-7146">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7147" />
                <span className="text-gray-700" data-id="element-7148">Tires</span>
              </div>
              <div className="flex items-start" data-id="element-7149">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7150" />
                <span className="text-gray-700" data-id="element-7151">Tire Inspections</span>
              </div>
              <div className="flex items-start" data-id="element-7152">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7153" />
                <span className="text-gray-700" data-id="element-7154">
                  Electrical System Inspection
                </span>
              </div>
              <div className="flex items-start" data-id="element-7155">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7156" />
                <span className="text-gray-700" data-id="element-7157">Brake System Inspection</span>
              </div>
            </div>

            <div className="text-center" data-id="element-7158">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/trailers.gif" alt="Trailer repair services" className="mx-auto" data-id="element-7159" />
            </div>
          </div>

          {/* Hitches & Additional Services */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7160">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-7161">
              Hitches & Additional Services
            </h2>

            <div className="space-y-6" data-id="element-7162">
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7163">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7164">
                  Hitch Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7165">
                  <div className="flex items-start" data-id="element-7166">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7167" />
                    <span className="text-gray-700" data-id="element-7168">5th Wheel Hitches</span>
                  </div>
                  <div className="flex items-start" data-id="element-7169">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7170" />
                    <span className="text-gray-700" data-id="element-7171">Class I-V Hitches</span>
                  </div>
                  <div className="flex items-start" data-id="element-7172">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7173" />
                    <span className="text-gray-700" data-id="element-7174">
                      Weight Distribution Hitches
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7175">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7176">
                  All Types of Trailers
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7177">
                  <div className="flex items-start" data-id="element-7178">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7179" />
                    <span className="text-gray-700" data-id="element-7180">Cargo</span>
                  </div>
                  <div className="flex items-start" data-id="element-7181">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7182" />
                    <span className="text-gray-700" data-id="element-7183">Utility</span>
                  </div>
                  <div className="flex items-start" data-id="element-7184">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7185" />
                    <span className="text-gray-700" data-id="element-7186">Dump</span>
                  </div>
                  <div className="flex items-start" data-id="element-7187">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7188" />
                    <span className="text-gray-700" data-id="element-7189">Travel</span>
                  </div>
                  <div className="flex items-start" data-id="element-7190">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7191" />
                    <span className="text-gray-700" data-id="element-7192">5 wheel</span>
                  </div>
                  <div className="flex items-start" data-id="element-7193">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7194" />
                    <span className="text-gray-700" data-id="element-7195">Gooseneck</span>
                  </div>
                  <div className="flex items-start" data-id="element-7196">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7197" />
                    <span className="text-gray-700" data-id="element-7198">Boat</span>
                  </div>
                </div>
              </div>

              <div className="bg-purple-50 rounded-lg p-6" data-id="element-7199">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7200">
                  Brake & Electrical Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7201">
                  <div className="flex items-start" data-id="element-7202">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7203" />
                    <span className="text-gray-700" data-id="element-7204">
                      Electric Brake Controls
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-7205">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7206" />
                    <span className="text-gray-700" data-id="element-7207">Electric Brake Repair</span>
                  </div>
                  <div className="flex items-start" data-id="element-7208">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7209" />
                    <span className="text-gray-700" data-id="element-7210">Electrical Repair</span>
                  </div>
                  <div className="flex items-start" data-id="element-7211">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7212" />
                    <span className="text-gray-700" data-id="element-7213">Surge Brake</span>
                  </div>
                  <div className="flex items-start" data-id="element-7214">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7215" />
                    <span className="text-gray-700" data-id="element-7216">Disc Brake Conversion</span>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-7217">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7218">
                  Performance & Additional Services
                </h3>
                <div className="grid md:grid-cols-2 gap-2" data-id="element-7219">
                  <div className="flex items-start" data-id="element-7220">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7221" />
                    <span className="text-gray-700" data-id="element-7222">Air Bags</span>
                  </div>
                  <div className="flex items-start" data-id="element-7223">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7224" />
                    <span className="text-gray-700" data-id="element-7225">Tow Performance</span>
                  </div>
                  <div className="flex items-start" data-id="element-7226">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7227" />
                    <span className="text-gray-700" data-id="element-7228">Fuel Economy</span>
                  </div>
                  <div className="flex items-start" data-id="element-7229">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7230" />
                    <span className="text-gray-700" data-id="element-7231">Sales & Service</span>
                  </div>
                  <div className="flex items-start" data-id="element-7232">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7233" />
                    <span className="text-gray-700" data-id="element-7234">Rewiring</span>
                  </div>
                  <div className="flex items-start" data-id="element-7235">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7236" />
                    <span className="text-gray-700" data-id="element-7237">Check Suspension</span>
                  </div>
                  <div className="flex items-start" data-id="element-7238">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7239" />
                    <span className="text-gray-700" data-id="element-7240">
                      Diesel Exhaust & Performance
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-7241">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7242" />
                    <span className="text-gray-700" data-id="element-7243">Installation</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7244">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7245">
              Certified Trailer Repair Services
            </h2>
            <p className="text-xl mb-6" data-id="element-7246">
              Licensed mechanics ensuring safety and reliability
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7247">
              <Phone className="mr-3" size={24} data-id="element-7248" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7249">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}